import { C as Component } from "./component-cLJ9vlHA.js";
import "./critical-Da0Dmhh9.js";
import "./utilities-2Suih3Nm.js";
class QuickViewToggle extends Component {
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  /**
   * Open the quick view dialog for a specific product.
   * @param {{ targetDialog: string, productHandle: string }} data
   * @param {Event} event
   */
  showQuickView(data, event) {
    event.preventDefault();
    event.stopPropagation();
    const dialog = document.querySelector(data.targetDialog);
    if (!dialog) {
      return;
    }
    if (typeof dialog.showDialogForProduct === "function") {
      dialog.showDialogForProduct(data.productHandle);
    }
  }
}
if (!customElements.get("quick-view-toggle")) {
  customElements.define("quick-view-toggle", QuickViewToggle);
}
